<template>
  <div class="mb-5">
    <PhotoFilters
      :filters="filters"
      :devices="devices"
      @update:filters="onFilterUpdate"
    />

    <PhotoList
      :photos="photos"
      :loading="isLoading"
      @photo-click="handlePhotoPreview"
      @photo-delete="confirmDeletePhoto"
    />

    <Pagination :pagination="pagination" @change="changePage" />

    <DeletePhotoModal
      ref="deletePhotoModal"
      :photo="selectedPhoto"
      @deleted="onPhotoDeleted"
    />

    <BootstrapModal
      ref="photoPreviewModal"
      modalId="photoPreviewModal"
      title="Photo Preview"
      closeText="Close"
      hideConfirmButton
    >
      <template #body>
        <div
          class="d-flex justify-content-center align-items-center"
          style="max-height: 70vh"
        >
          <img :src="selectedPhoto?.s3_url" class="img-fluid" alt="Photo" />
        </div>
      </template>
    </BootstrapModal>
  </div>
</template>

<script>
import BootstrapModal from "@/components/Common/BootstrapModal.vue";
import DeletePhotoModal from "@/components/Photo/DeletePhoto.vue";
import PhotoService from "@/services/photoService.js";
import PhotoFilters from "@/components/Photo/PhotoFilters.vue";
import PhotoList from "@/components/Photo/PhotoList.vue";
import Pagination from "@/components/Common/Pagination.vue";

export default {
  name: "PhotosList",
  components: {
    BootstrapModal,
    DeletePhotoModal,
    PhotoFilters,
    PhotoList,
    Pagination,
  },
  data() {
    const today = new Date();
    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(today.getDate() - 7);
    const format = (d) => d.toISOString().split("T")[0];

    return {
      selectedPhoto: null,
      isLoading: false,
      filters: {
        startDate: format(oneWeekAgo),
        endDate: format(today),
        deviceId: "",
        userPhotos: true,
        testPhotos: false,
        colored: true,
        bw: true,
        coin_1: true,
        coin_2: true,
        coin_3: true,
      },
      clientOptions: [0, 1, 3, 30, 32, 36],
      devices: [],
      photos: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
      },
      inputPage: 1,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData(page = 1) {
      this.isLoading = true;
      try {
        const data = await PhotoService.getPhotos({ ...this.filters, page });
        this.photos = data.photos;
        this.devices = data.devices;
        this.pagination = data.meta;
        this.pagination.current_page = page;
        this.inputPage = page;
      } catch (error) {
        console.error("Error fetching photos:", error);
      } finally {
        this.isLoading = false;
      }
    },
    onFilterUpdate(updatedFilters) {
      this.filters = { ...updatedFilters };
      this.fetchData();
    },
    selectPhoto(photo) {
      console.log(photo);
    },
    changePage(page) {
      const pageNum = Number(page);
      if (
        !Number.isInteger(pageNum) ||
        pageNum < 1 ||
        pageNum > this.pagination.last_page ||
        pageNum === this.pagination.current_page
      ) {
        return;
      }

      this.fetchData(pageNum);
    },
    handlePhotoPreview(photo) {
      this.selectedPhoto = photo;
      this.$refs.photoPreviewModal?.show();
    },
    confirmDeletePhoto(photo) {
      this.selectedPhoto = photo;
      this.$refs.deletePhotoModal.show();
    },
    onPhotoDeleted(photoId) {
      this.photos = this.photos.filter((p) => p.id !== photoId);
    },
  },
};
</script>
<style lang="scss" scoped>
.pagination-wrapper {
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  padding: 0.5rem;
}
</style>